import { toast } from "react-toastify";

function Campo({ label, valor }) {
    if (valor === null || valor === undefined || valor === "") return null;

    const copiar = async () => {
        try {
            await navigator.clipboard.writeText(String(valor));
            toast.success(`${label} copiado`, { autoClose: 500 });
        } catch {
            toast.error("Não foi possível copiar");
        }
    };

    return (
        <div className="min-w-0">
            <span className="block text-[11px] uppercase tracking-wide text-muted-foreground font-semibold">{label}</span>
            <button
                type="button"
                onClick={copiar}
                className="block w-full text-left text-foreground font-medium truncate cursor-copy hover:text-primary"
                title={`${valor} — clique para copiar`}
            >
                {valor}
            </button>
        </div>
    );
}

export default Campo;
